<template>
  <div class="root" style="">
    <p class="mode">
      <span>{{ cityDetail.ZCZSName || "资产招商" }}</span>

      <router-link :to="{ name: '资产招商', query: { dm: deptId } }"
        >更多></router-link
      >
    </p>
    <XYJingMu
      v-if="cityDetail.cityName == '信阳市'"
      :xiangmuList="dataList"
    ></XYJingMu>
    <jing-mu v-else :xiangmuList="dataList"></jing-mu>

    <div
      style="display: flex; align-items: center; justify-content: end"
      v-if="dataList.length"
    >
      <el-pagination
        layout="prev, pager, next, total"
        :total="listTotal"
        @prev-click="prevClick"
        @next-click="nextClick"
        @current-change="currentChange"
        :page-size="4"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import JingMu from '../JingMu.vue'
import XYJingMu from '../XYJingMu.vue'
import { getTenderList } from '../../../api/资产招商'
import { cityDetail } from '../../../util/mainOption'

export default {
  components: {
    JingMu,
    XYJingMu,

  },
  data () {
    return {
      dataList: [],
      deptId: null,
      listTotal: 0,
      pageNo: 1,
      pageSize: 4,
    }
  },
  created () {
    this.deptId = this.$route.query.deptId ? this.$route.query.deptId : null
    this.requestList()
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    // 跳转到竞价项目详情页面
    toJingjia2 (i) {
      this.$router.push({ name: '竞价项目详情', query: { id: i } })
    },
    requestList () {
      let data = {
        pageNum: this.pageNo,
        pageSize: 4,
        deptId: this.deptId,
      }
      getTenderList(data).then((res) => {
        this.dataList = res.data.rows
        this.listTotal = res.data.total
      })
    },
    prevClick () {
      this.pageNo--
      this.requestList()
    },
    nextClick () {
      this.pageNo++
      this.requestList()
    },
    currentChange (i) {
      this.pageNo = i
      this.requestList()
    },
  },
}
</script>

<style scoped>
p {
  margin: 0;
}

a {
  text-decoration: none;
}

.root {
  /* min-height: 1180px; */
  width: 100%;
  /* min-height: 599px; */
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 61px 0 37px;
  /* width: 1174px; */
  height: 80px;
  color: #2187ff;
  border-bottom: 1px solid #2187ff;
}

.mode > span {
  display: block;
  width: auto;
  height: 50px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  padding-left: 5px;
  border-left: #2187ff 6px solid;
  line-height: 50px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2187ff;
  line-height: 80px;
}

.table {
  width: 100%;
}

.table tr {
  cursor: pointer;
}

.first_tr {
  width: 100%;
  height: 75px;
}

.first_tr th {
  height: 75px;

  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 75px;
}

td {
  max-width: 254px;
  height: 51px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 51px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
